import React from "react";

const IconPDF = () => {
    return (
        <svg
            width="19"
            height="24"
            viewBox="0 0 19 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="presentation"
        >
            <path
                d="M3 23H16C17.1046 23 18 22.1046 18 21V8.58509C18 8.11363 17.8334 7.65732 17.5297 7.29671L12.8258 1.71161C12.4457 1.26042 11.8859 1 11.296 1H3C1.89543 1 1 1.89543 1 3V21C1 22.1046 1.89543 23 3 23Z"
                fill="currentColor"
                fillOpacity="0.1"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinejoin="round"
            />
            <path
                d="M4.55475 19H5.17075V18.16H5.63875C6.26675 18.16 6.77075 17.824 6.77075 17.176V17.168C6.77075 16.596 6.36675 16.2 5.69875 16.2H4.55475V19ZM5.17075 17.612V16.756H5.64675C5.95475 16.756 6.14675 16.904 6.14675 17.18V17.188C6.14675 17.428 5.96675 17.612 5.65875 17.612H5.17075ZM7.22663 19H8.31863C9.19863 19 9.80663 18.388 9.80663 17.6V17.592C9.80663 16.804 9.19863 16.2 8.31863 16.2H7.22663V19ZM7.84263 18.444V16.756H8.31863C8.82263 16.756 9.16263 17.104 9.16263 17.6V17.608C9.16263 18.104 8.82263 18.444 8.31863 18.444H7.84263ZM10.3555 19H10.9715V17.916H12.3075V17.356H10.9715V16.76H12.4875V16.2H10.3555V19Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default IconPDF;
